import React from 'react';
import Plot from '../../components/Plot';


function Windspeed({ size, sensors }) {
  
  return (
    <Plot size={size}>
      {({ xScale, yScale }) => sensors.map(sensor => {
        const x = xScale(sensor.x);
        const y = yScale(sensor.y);
        const transform = `translate(${x}, ${y}) rotate(${sensor.direction})`;
        return (
          <g
            transform={transform}>
            <path
              d={`M0 0 L0 -${sensor.speed}`}
              stroke="blue"
              stroke-width={2}
              fill="none"  
            />
            <polygon
              points={`-2,-${sensor.speed - 4} 0,-${sensor.speed} 2,-${sensor.speed - 4}`}
              stroke="blue"
              stroke-width={1}
              fill="blue"  
            />
          </g>
        )
      })}
    </Plot>
  )
}

Windspeed.defaultProps = {
  offset: {
    x: 0,
    y: 0,
  },
}

export default Windspeed;



// WEBPACK FOOTER //
// ./src/plots/Windspeed/Windspeed.component.js